export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7103.0c28207a.jpg";